<template>
  <div class="services-page">
    <!-- Banner -->
    <div class="page_vision_banner">
      <img src="/images/page_banner_news.jpg">
      <h3>
        <span>服务介绍</span>
        <font></font>
        <strong>华合半导体将为您分享更多芯片和半导体业界的新进展</strong>
      </h3>
    </div>

    <!-- 面包屑 -->
    <div class="page_dg">
      <div>
        <left>
          <router-link to="/">主页</router-link> &gt;
          <router-link to="/services">服务介绍</router-link>&gt;
          <router-link to="/">{{menu}}</router-link>
        </left>
      </div>
    </div>

    <!-- 服务列表 -->
    <div class="page_news">
      <div class="page_news_list">
        <left>
          <dl>
            <a v-for="(service, index) in serviceList.records" :key="index" @click="goToDetail(service)">
              <img :src="service.newImg">
              <h2>
                <b>{{ service.newNameCn }}</b>
                <c>{{ service.newSynopsisCn }}</c>
                <span class="read-more">阅读全文 &gt;</span>
                <e>{{ service.createTime }}</e>
              </h2>
            </a>
            <div class="feiye">
              共<strong>1</strong>页 <strong>{{ serviceList.total }}</strong>条
            </div>
          </dl>
        </left>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Products',
  metaInfo() {
    const menu = this.$route.query.menu || '服务介绍'
    return {
      title: `${menu}_南京华合半导体_化合物半导体服务`,
      meta: [
        { name: 'description', content: `南京华合半导体${menu}服务，专业提供化合物半导体器件模型提取、PDK开发、IP设计等全产业链技术服务。` },
        { name: 'keywords', content: `${menu},化合物半导体,器件模型,PDK开发,IP设计,南京华合半导体` },
        { name: 'robots', content: 'index,follow' }
      ]
    }
  },
  data() {
    return {
      menu: '',
      serviceList: [
        {
          image: require('@/assets/images/1-25010211442L53.png'),
          title: '器件模型提取',
          summary: '华合半导体已开发多种GaAs/GaN工艺的有源和无源商业化工艺制程器件模型：Ø GaAs/GaN HEMT 小信号模型Ø GaAs/GaN HEMT 可缩放大...',
          date: '2025/01/03',
          link: '/services'
        }
      ]
    }
  },
  created() {
    this.menu = this.$route.query.menu
   
    this.$request.get('/wx/news/getListByClassIfy',{"newType": this.$route.query.type} ).then(response => {
      this.serviceList = response.data
    })
  },
  methods: {
    goToDetail(service) {
         if(service.newNameEn){
        window.open(service.newNameEn)
        return 
      }
      this.$router.push({
        path: '/services/detail',
        query: { id: service.id ,menu: this.menu,type: this.$route.query.type}
      })
    }
  },
    watch: {
    '$route.query.menu'() {
      // console.log('路由变化了')
      this.menu = this.$route.query.menu
   
    this.$request.get('/wx/news/getListByClassIfy',{"newType": this.$route.query.type} ).then(response => {
      this.serviceList = response.data
    })
    }
  }
}
</script>

<style scoped>
.read-more {
  color: #0aacf2;
  font-size: 15px;
}

@media screen and (max-width: 740px) {
  .read-more {
    font-size: 12px;
    color: #0aacf2;
    margin-top: 0.5em;
  }
  .page_vision_banner {
        height: 150px;
        padding-top: 54px;
    }
}


</style>
